

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { TownDialogboxComponent } from '../town-dialogbox/town-dialogbox.component';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-town-data',
  templateUrl: './town-data.component.html',
  styleUrls: ['./town-data.component.scss']
})
export class TownDataComponent implements OnInit {
  APIService: string;
  dialogRef: MatDialogRef<any>;
  TownSearchForm: FormGroup;
  townList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  SessionNo: any;
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.TownSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
    this.getTownData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getTownData();
    this.keypress();
  }
  
  getTownData() {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getTown(payload).subscribe(res => {
      this.spinner.hide();
      this.townList = res.data;
      this.totalItems = res.data[0].TotalRecords;
    
    });
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.townList = [];
      let payload = {}
      payload['SearchString'] = this.TownSearchForm.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.searchTown(payload).subscribe(res => {
        if(res.status){
          this.townList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.townList = [];
        this.totalItems = 0;
        }
       
      }, (ERROR: HttpErrorResponse) => {
        this.townList = [];
      });
    },1000)
   
  }
 

  addnewrecord() {
    const dialogRef = this.dialog.open(TownDialogboxComponent, {
      width: '80vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getTownData();
      this.TownSearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k) {
    const dialogRef = this.dialog.open(TownDialogboxComponent, {
      width: '80vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.getTownData();
      this.TownSearchForm.controls['SearchString'].setValue('');
    });
  }

  deleteData(k) {
    const dialogRef = this.dialog.open(TownDialogboxComponent, {
      width: '80vh',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getTownData();
      this.TownSearchForm.controls['SearchString'].setValue('');
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  Print(){
    let submitpayload = this.TownSearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['SearchString'],
    payload1['MenuName'] ='Master-Town';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 115,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

}
